import Vue from 'vue'
import 'moment/locale/ja'
import moment from 'moment'
import sanitizeHTML from 'sanitize-html'
import store from '@/store'
import { REG_EXP, BYTE_UNITS } from '@/lib/constants'

export default function() {
  Vue.filter('moment', function (value, format) {
    if (!value) return ''
    return moment(value).format(format)
  })

  Vue.filter('momentDiff', function (value) {
    if (!value) return ''
    const daysDiff = -moment(value).diff(moment(new Date), 'days')
    if (daysDiff) {
      return `${daysDiff}日前`
    } else {
      const hoursDiff = -moment(value).diff(moment(new Date), 'hours')
      if (hoursDiff) {
        return `${hoursDiff}時間前`
      } else {
        return `${-moment(value).diff(moment(new Date), 'minutes')}分前`
      }
    }
  })

  Vue.filter('currencyJPY', function(value) {
    const isMinus = value < 0
    const formatter = new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: 'JPY'
    })
    const formattedValue = formatter.format(Math.abs(value))
    if (isMinus) {
      return formattedValue.slice(0, 1) + '-' + formattedValue.slice(1, formattedValue.length)
    } else {
      return formattedValue
    }
  })

  Vue.filter('autoLink', function (value) {
    let result = value

    result = sanitizeHTML(result, {
      allowedTags: [],
      allowedAttributes: { '*': ['*'] },
      disallowedTagsMode: 'escape'
    })

    result = result.replace(REG_EXP.url, "<a href='$1' target='_blank'>$1</a>")
    return result
  })

  function formatChatPostContent(value) {
    let result = value

    // NOTE: </a> => $**/a**$
    result = result.replace(REG_EXP.closeTag, '$**/$1**$')

    // NOTE: < => $###$
    result = result.replace(REG_EXP.tagSymbol, '$###$')

    result = sanitizeHTML(result, {
      allowedTags: [],
      allowedAttributes: { '*': ['*'] },
      disallowedTagsMode: 'escape'
    })

    // NOTE: $###$ => &lt;
    result = result.replace(REG_EXP.uniqueTagSymbol, '&lt;')

    // NOTE: &lt;/a&gt; => 空文字
    result = result.replace(REG_EXP.escapedCloseTag, '')

    // NOTE: $**/a**$ => &lt;/a&gt;
    result = result.replace(REG_EXP.uniqueCloseTag, '&lt;/$1&gt;')

    // NOTE: AutoLink
    result = result.replace(REG_EXP.url, "<a href='$1' target='_blank'>$1</a>")

    // NOTE: Blockquote
    result = result.replace(REG_EXP.quotationLine, "<div class='blockquote'>$2</div>")

    return result
  }

  Vue.filter('formatChatPostContent', function (value) {
    return formatChatPostContent(value)
  })

  Vue.filter('formatChatPostContentWithMention', function (value) {
    let result = formatChatPostContent(value)

    // $1: displayName
    // $2: id
    result = result.replace(REG_EXP.mentionSymbol, (_, $1, $2) => {
      let classes = 'chat-post-mention'
      if (!$2) {
        classes += ' all'
      } else if ($2 == store.getters['auth/signedInUser']?.id) {
        classes += ' myself'
      }
      return `<span class="${classes}" data-mention-user-id="${$2}">@${$1}</span>`
    }).replace(REG_EXP.taskTagSymbol, (_, $1, $2) => {
      return `<span class="chat-post-tag" data-task-card-id="${$2}">#${$1}</span>`
    })

    return result
  })

  Vue.filter('formatByteDisplay', function (value) {
    let target
    let unit = 'byte'

    if (value >= BYTE_UNITS.mb) {
      target = BYTE_UNITS.mb
      unit = 'MB'
    } else if (value >= BYTE_UNITS.kb) {
      target = BYTE_UNITS.kb
      unit = 'KB'
    }
    return (target ? Math.floor((value / target) * 100) / 100 : value) + unit
  })
}
